/* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import Hammer from "@egjs/hammerjs";
import { State } from "../State";
import PressGestureHandler from "./PressGestureHandler";
import { isnan, isValidNumber } from "./utils";
var LongPressGestureHandler = /*#__PURE__*/ function(PressGestureHandler) {
    "use strict";
    _inherits(LongPressGestureHandler, PressGestureHandler);
    var _super = _create_super(LongPressGestureHandler);
    function LongPressGestureHandler() {
        _class_call_check(this, LongPressGestureHandler);
        return _super.apply(this, arguments);
    }
    _create_class(LongPressGestureHandler, [
        {
            key: "minDurationMs",
            get: function get() {
                // @ts-ignore FIXNE(TS)
                return isnan(this.config.minDurationMs) ? 251 : this.config.minDurationMs;
            }
        },
        {
            key: "maxDist",
            get: function get() {
                // @ts-ignore FIXNE(TS)
                return isnan(this.config.maxDist) ? 9 : this.config.maxDist;
            }
        },
        {
            key: "updateHasCustomActivationCriteria",
            value: function updateHasCustomActivationCriteria(param) {
                var maxDistSq = param.maxDistSq;
                return !isValidNumber(maxDistSq);
            }
        },
        {
            key: "getConfig",
            value: function getConfig() {
                if (!this.hasCustomActivationCriteria) {
                    // Default config
                    // If no params have been defined then this config should emulate the native gesture as closely as possible.
                    return {
                        shouldCancelWhenOutside: true,
                        maxDistSq: 10
                    };
                }
                return this.config;
            }
        },
        {
            key: "getHammerConfig",
            value: function getHammerConfig() {
                return _object_spread_props(_object_spread({}, _get(_get_prototype_of(LongPressGestureHandler.prototype), "getHammerConfig", this).call(this)), {
                    // threshold: this.maxDist,
                    time: this.minDurationMs
                });
            }
        },
        {
            key: "getState",
            value: function getState(type) {
                var _obj;
                return (_obj = {}, _define_property(_obj, Hammer.INPUT_START, State.ACTIVE), _define_property(_obj, Hammer.INPUT_MOVE, State.ACTIVE), _define_property(_obj, Hammer.INPUT_END, State.END), _define_property(_obj, Hammer.INPUT_CANCEL, State.FAILED), _obj)[type];
            }
        }
    ]);
    return LongPressGestureHandler;
}(PressGestureHandler);
export default LongPressGestureHandler;
